// extracted by mini-css-extract-plugin
export default {"saveButtonContainer":"ConsumerInfo_saveButtonContainer__tTmVM","submitButton":"ConsumerInfo_submitButton__35vM4"};